import { SuccessResponse } from '../request-response';
import { ResourceName } from '../resource-name';

export const SessionGate = {
  resource: ResourceName.session,
  actions: {
    createSession: 'create-session',
    launchSession: 'launch-session',
    launchFreeTrialSession: 'launch-free-trial-session',
    endSession: 'end-session',
    pingSession: 'ping-session',
    addFeedback: 'add-feedback',
  },
};

export type SessionGateActionTypes = {
  createSession: {
    request: CreateSessionRequest;
    response: any;
  };
  launchSession: {
    request: SessionIdRequest;
    response: undefined;
  };
  launchFreeTrialSession: {
    request: SessionIdRequest;
    response: undefined;
  };
  endSession: {
    request: EndSessionRequest;
    response: undefined;
  };
  pingSession: {
    request: SessionIdRequest;
    response: SuccessResponse;
  };
  addFeedback: {
    request: AddFeedbackRequest;
    response: any;
  };
};

export interface AddFeedbackRequest {
  workspaceId: string;
  sessionMessageId: string;
  feedback: string;
}

export interface EndSessionRequest {
  sessionId: string;
  recordingUrl: string;
}

export interface CreateSessionRequest {
  templateId: string;
}

export interface SessionIdRequest {
  id: string;
}

export enum PingSessionErrCodes {
  STATUS_NOT_ONGOING = 'STATUS_NOT_ONGOING',
  NO_STATUS_TIME_STR = 'NO_STATUS_TIME_STR',
  NO_CREDITS = 'NO_CREDITS',
  NOT_FOUND = 'NOT_FOUND',
}
